/** @module csi/widget/_HasDropDownMixin */
define([
	"dojo/_base/declare",
	"csi/html",
	"./_ScopeScrollMixin"
], function(declare, html, _ScopeScrollMixin) {

	/**
	 * This module should only be used for controls which use _HasDropDown mixin
	 * This mixin will close drop down when control become not visible or partially visible    
	 */

	return declare(_ScopeScrollMixin, {
		/** @property {element} _backDrop - a backdrop blocking clicks behind the dropdown */
		_backDrop: null,

		/**
		 * @override
		 * Add intersection observer 
		 */
		openDropDown: function() {
			this.inherited(arguments);

			// in case of delayed search we will add special placeholder, after which we need to re-calculate dropdown placement (re-open dropdown)
			if (this.dropDown?.createDelayedPlaceholder?.()) {
				this.openDropDown();
			};

			if (this.bDelayFiltering && !this.bShowHybridList) {
				this.dropDown?.createDelayFilteringPlaceholder?.();
			}

			this.addIntersectionObserver(this.domNode, () => this.closeDropDown());
			this.addBackDrop();
		},

		/**
		 * return zIndex of popup's root Element
		 * @param {HTMLElement} node 
		 * @returns number
		 */
		getRootZIndex(node) {
			while (node && node.parentNode!=document.body) {
				node = node.parentNode;
			}
			if (node) {
				// "|| 0" will substitute empty string with zero
				return node.style.zIndex || 0;
			}
			return 0;
		},

		/**
		 * create new or attach existing back drop
		 */
		addBackDrop() {
			if (!this._backDrop && this.dropDown) {
				// offsetWidth is 0 for CMS in Dropdown
				const node = (this.domNode.offsetWidth == 0) ? this.dropDown.domNode : this.domNode;
				const zIndex = this.getRootZIndex(node);
				// no reason to add backDrop if there are no popup (zIndex == 0)
				if (zIndex) {
					this._backDrop = html.create("div", {
						className: "csi-dropdown-backdrop",
						style: {zIndex:zIndex - 1},
						onclick: (e) => {
							this._onBlur(); 
							this.onEscape?.()
						},
					}, document.body);
				}
			} else if (this.dropDown) {
				// On the first time the dropdown is loaded, the backdrop is created, and on subsequent opens it should be reattached
				document.body.appendChild(this._backDrop);
			}
		},

		/**
		 * remove but not destroy back drop, allow to reuse it
		 */
		removeBackDrop() {
			this._backDrop?.remove();
		},

		/**
		 * @override
		 * Remove intersectionObserver
		 */
		closeDropDown: function(focus) {
			this.removeIntersectionObserver();
			this.removeBackDrop();

			this.inherited(arguments);
		}

	});
});